import { Empty as Em } from 'antd';
import type { EmptyProps } from 'antd/es/empty';
import style from './Empty.module.less';

const Empty: React.FC<EmptyProps> = props => {
  return (
    <div className={style.emptyWrapper} {...props}>
      <Em
        description={props.description}
      />
    </div>
  );
};

export default Empty;